// TODO: order of pipelines is important
import influencer from './influencer'
import app from './app'
import embedPartner from './embedPartner'
import syndication from './syndication'
import paid from './paid'
import social from './social'
import trPartner from './trPartner'
import organic from './organic'
import navigation from './navigation'
import rss from './rss'
import referral from './referral'
import direct from './direct'

export default [
  influencer,
  app,
  embedPartner,
  syndication,
  paid,
  social,
  trPartner,
  organic,
  navigation,
  rss,
  referral,
  direct,
]



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/trafficAnalyzer/pipelines/index.js